<section>
  <div class="header">
    <h1>{{ title | translate }}</h1>
  </div>
  <form class="filter astral-stack-m" [formGroup]="filter" (ngSubmit)="onFilter()">
    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <astral-date-picker
        [control]="filter.controls['from']"
        [label]="'PAYMENT.PAYMENTS_FROM'"
        [model]="from"
        [isRequired]="true"
      ></astral-date-picker>
      <astral-date-picker
        [control]="filter.controls['to']"
        [label]="'PAYMENT.PAYMENTS_TO'"
        [model]="to"
        [isRequired]="true"
      ></astral-date-picker>
      <app-autocomplete-remote-paged
        [service]="companyService"
        [defaultSearch]="'*'"
        [control]="filter.controls['company']"
      ></app-autocomplete-remote-paged>
      <astral-input [control]="filter.controls['verDescription']"></astral-input>
      <astral-input [control]="filter.controls['debtorName']"></astral-input>
      <astral-date-picker
        [control]="filter.controls['dueDateFrom']"
        [label]="'DUE_PERIODS.INVOICE_PERIOD_FROM'"
      ></astral-date-picker>
      <astral-date-picker
        [control]="filter.controls['dueDateTo']"
        [label]="'DUE_PERIODS.INVOICE_PERIOD_TO'"
      ></astral-date-picker>
      <div class="astral-form-adjacent-action">
        <astral-button variant="secondary" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
      </div>
    </astral-layout-group>
  </form>
  <app-multiselect-list-view
    [columnDefinition]="columnDefinition"
    [menuDefinition]="menuDefinition"
    [itemsSource]="itemsSource"
    [preferencesKey]="'invoice.bg-payment-manager.list'"
  ></app-multiselect-list-view>
</section>
